import { LoginProviderByFirebaseProviderId } from '@/enums/login';

import {
	EmailAuthProvider,
	getAuth,
	OAuthProvider,
	reauthenticateWithCredential,
	reauthenticateWithPopup,
} from 'firebase/auth';
import Cookies from 'js-cookie';

export const cookieSharedDomainConf =
	process.env.NODE_ENV === 'development'
		? {}
		: {
				domain: `.${JW_CONFIG.DOMAIN}`,
				path: '/',
		  };

export function removeAccessTokenFromCookies() {
	// this to make sure to remove old access_token cookies (without the domain and path).
	Cookies.remove('access_token');
	Cookies.remove('access_token', {
		...cookieSharedDomainConf,
	});
}

export function saveAccessTokenToCookies(token: string, expires: number | Date = 365) {
	removeAccessTokenFromCookies();
	Cookies.set('access_token', token, {
		expires,
		secure: true,
		sameSite: 'lax',
		...cookieSharedDomainConf,
	});
}

export function getAuthTokenFromCookies(): string | undefined {
	return Cookies.get('access_token');
}

export async function reauthenticateSocialAuth(provider: string): Promise<boolean> {
	try {
		const user = await currentUser();
		if (!user) return false;
		await reauthenticateWithPopup(user, new OAuthProvider(LoginProviderByFirebaseProviderId[provider]));
		return true;
	} catch (error) {
		return false;
	}
}

export function currentUser(): Promise<any> {
	return new Promise((resolve, reject) => {
		const auth = getAuth();
		if (auth.currentUser) {
			resolve(auth.currentUser);
		}
		const unsubscribe = auth.onAuthStateChanged((user: any) => {
			unsubscribe();
			resolve(user);
		}, reject);
	});
}

export async function generateToken() {
	try {
		const user = await currentUser();

		if (!user) {
			throw new Error('Error getting firebase user');
		}

		const token = await user.getIdToken();
		return token;
	} catch (error) {
		// no error caught, because it's already caught outside of generateToken().
	}
}

export async function reauthenticateUserWithPassword(password: string) {
	try {
		const user = await currentUser();
		if (!user) return false;
		const credential = EmailAuthProvider.credential(user.email, password);
		await reauthenticateWithCredential(user, credential);
		return true;
	} catch (error) {
		return false;
	}
}
